export default class NullableCallInvitationError extends Error {
  constructor() {
    super('Call invitation is null')
    this.name = 'NullableCallInvitationError'
  }
}
